import { ListItemIcon, Typography } from '@mui/material';
import type { SnackbarOrigin } from 'notistack';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkIcon } from 'assets/icons';
import { analytics, events } from 'services/analytics';
import { StyledMenuItem } from './styled';

type PropsType = {
  copySongURL: string;
};

const SNACKBAR_AUTO_HIDE_DURATION = 4000;

const CopyLinkButton = ({ copySongURL }: PropsType) => {
  const { t } = useTranslation();

  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = useCallback(() => {
    const anchorOrigin: SnackbarOrigin = {
      vertical: 'top',
      horizontal: 'center',
    };
    enqueueSnackbar(t('general:action:linkCopied'), {
      variant: 'success',
      anchorOrigin,
      autoHideDuration: SNACKBAR_AUTO_HIDE_DURATION,
    });
  }, [t, enqueueSnackbar]);

  const handleCopyLinkClick = useCallback(() => {
    navigator.clipboard.writeText(copySongURL);
    showSnackbar();
    analytics.track(events.copySongClick());
  }, [copySongURL, showSnackbar]);

  return (
    <StyledMenuItem onClick={handleCopyLinkClick}>
      <ListItemIcon>
        <LinkIcon />
      </ListItemIcon>
      <Typography>{t('general:action:copyLink')}</Typography>
    </StyledMenuItem>
  );
};

export default CopyLinkButton;
